module.exports = __webpack_public_path__ + "media/images/icon__reddit@2x-21889e8a2bae665725b5fb38f01a6519.png";